import {createSlice} from '@reduxjs/toolkit'

const initialMessage = () => {
    return {}
}

export const messageSlice = createSlice({
    name: 'message',
    initialState: {
        data: initialMessage()
    },
    reducers: {
        setMessage: (state, action) => {
            state['data'] = action.payload
        }
    }
})

export const {setMessage} = messageSlice.actions

export default messageSlice.reducer